import React from "react";
import { Switch, Route } from "react-router-dom";
import Login from "./pages/login/login";
import ChangePassword from "./pages/changePassword/ChangePassword";
import ErrorPage from "./components/error/ErrrorPage";
import MFAScan from "./pages/mfasetup/mfascan/mfascan";
import PersonIcon from '@material-ui/icons/Person';
import MFAVerification from "./pages/mfaverification/mfaverification";
import {
    CHANGE_PASSWORD_ROUTE,
    FIRST_TIME_CHANGE_PASSWORD_ROUTE,
    FORGOT_CONFIRM_OTP_PASSWORD_ROUTE,
    FORGOT_CONFIRM_PASSWORD_ROUTE,
    FORGOT_PASSWORD_ROUTE, HOMEPAGE_ROUTE,
    LOGIN_ROUTE,
    MFA_SETUP_ROUTE,
    MFA_VERIFICATION_ROUTE
} from "./constants/routeconstants";
import ResetPassword from "./pages/resetpassword/resetpassword";
import ConfirmResetPassword from "./pages/confirmresetpassword/confirmresetpassword";
import ConfirmOTPResetPassword from "./pages/confirmresetpassword/confirmotpresetpassword";
import HeaderComponent from "./components/header/headercomponent";
import HomePage from "./pages/home/home";

function Routes() {
    const changePassword = ()=>{

    }

    const handleLogout = ()=>{

    }
    const [state,setState] = React.useState({
        type: "",
        allList:[],
        access:{
            baAccess: false,
            hrAccess: false,
        },
        headerList:[
            {
                name:"accountList",
                icon:<PersonIcon/>,
                menuList:[
                    {
                        type:"cp",
                        text:"Change Password",
                        customFunc:changePassword,
                        access:true
                    },
                    {
                        type:"logout",
                        text:"Logout",
                        customFunc:handleLogout,
                        access:true
                    }
                ]
            }
        ]   })


    const headerList = state.headerList

    return (

        <Switch>
            <Route exact path={LOGIN_ROUTE} component={Login} />
            <Route exact path={HOMEPAGE_ROUTE} component={HomePage}/>
            <Route
                // key={FIRST_TIME_CHANGE_PASSWORD_URL}
                exact
                path={FIRST_TIME_CHANGE_PASSWORD_ROUTE}
                component={ChangePassword}
            />
            <Route
                // key={CHANGE_PASSWORD_URL}

                path={CHANGE_PASSWORD_ROUTE}
                component={ChangePassword}
            />
            <Route
                exact
                path={MFA_SETUP_ROUTE}
                component={MFAScan}
            />
            <Route
                exact
                path={MFA_VERIFICATION_ROUTE}
                component={MFAVerification}
            />
            <Route
                exact
                path={FORGOT_PASSWORD_ROUTE}
                component={ResetPassword}
            />
            <Route
                exact
                path={FORGOT_CONFIRM_PASSWORD_ROUTE}
                component={ConfirmResetPassword}
            />
            <Route
                exact
                path={FORGOT_CONFIRM_OTP_PASSWORD_ROUTE}
                component={ConfirmOTPResetPassword}
            />
            {/*<Route path={"/geoupload/*"}*/}
            {/*component={()=>{return window.location.href="https://dslmonitoring.net:3338"}}*/}
            {/*    />*/}
            <Route component={ ErrorPage }/>
            {/* <Route path="/home" component={HomePage} /> */}
        </Switch>


    );
}

export default Routes
// export default withRouter(App);
